module.exports = __webpack_public_path__ + "static/img/47.a99b1aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/47.png
// module id = LGNm
// module chunks = 0